"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBizone = void 0;
var _utils_1 = require("../_utils");
var methods_to_call_1 = require("../_utils/methods-to-call");
var call_window_bizone_1 = require("./call-window-bizone");
var initBizone = function () {
    (0, _utils_1.registerScript)({
        src: "https://static-basket-02.wbbasket.ru/vol20/sec/0.0.1/bizone/bfd_3.19.js",
        onLoad: function () {
            (0, call_window_bizone_1.callWindowBizone)(function () {
                console.log("call window.bfd");
            });
            if (methods_to_call_1.bizoneMethods.methodsToCall.length > 0) {
                console.log("process delayed calls to window.bfd");
                methods_to_call_1.bizoneMethods.methodsToCall.forEach(function (m) {
                    m();
                });
            }
        },
    });
};
exports.initBizone = initBizone;
//# sourceMappingURL=init-bizone.js.map